<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Tooltip from '$lib/components/Tooltip/Tooltip.svelte';
	import copyToClipboard from '$lib/utils/copyToClipboard';
	import { toastMessages } from '$lib/stores/toastMessageStore';
	import { _ } from 'svelte-i18n';

	export let name = '';
	export let value: string | undefined;
</script>

<div class="dataRow">
	<span>{name}</span>
	<span>{value ?? 'N/A'}</span>
	{#if value}
		<span class="iconPlaceHolder">
			<Tooltip text="copy">
				<Icon
					icon="content"
					size="12"
					onClick={() => {
						copyToClipboard(value || '');
						toastMessages.success($_('hubs.item.copied', { values: { item: name } }));
					}}
				/>
			</Tooltip>
		</span>
	{/if}
</div>

<style>
	.dataRow {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		padding-block: var(--gutterSmaller);
		padding-inline: 0;
		color: var(--grayMedium);
		font-size: var(--fontSizeSmaller);
	}

	.dataRow span {
		inline-size: auto;
	}

	.dataRow span:first-child::after {
		content: ':';
		padding-block: 0;
		padding-inline: var(--gutterSmaller);
	}

	.iconPlaceHolder {
		block-size: 100%;
		inline-size: 30px !important;
	}

	:global(.dataRow .px-icon) {
		display: none;
	}

	:global(.dataRow:hover .px-icon) {
		display: block;
	}
</style>
